import EmployeeDetails from '../utils/property-file/Employeedetails.json';

const apiName = {
    login: "user/login/web",
    forgot: "user/web/forgot/password",
    companyProfile: "user/add/company/profile",
    officeTiming: "user/add/office/time",
    adminProfile: "user/add/admin",
    apiKey: "AIzaSyCiY3A_FASmHXPwvJgWo28dxGZ1xy_lYvs",
    getAttendance: "user/get/all/details",
    showEmployeeStatus: "user/get/emp/data",
    uploadImg: "user/upload/profile/pic",
    logout: "user/logout",
    addEmployee: "user/register",
    getEmployeeInformation: "user/view/emp",
    adminProfileUpload: "user/upload/admin/profile/pic",
    changeLoginPassword: "user/change/company/password",
    removeEmployee: "user/remove/emp",
    editEmployeeDetails: "/user/edit/details",
    getCompanyDetails: "user/view/companyDetails",
    editCompanyDetails: "user/edit/company/profile",
    addHoliday: "user/add/holiday",
    getCompanyHoliday: "user/get/company/holiday",
    deleteHoliday: "/user/del/holiday",
    getHolidayInformation: "/user/get/holiday/detail",
    editHoliday: "/user/edit/holiday",
    makeAdmin: "/user/make/admin",
    selectApprovers: "/user/view/approver/web",
    getApproversInProfile: "/user/show/approvers/web",
    sendToken: "/user/get/token",
    getNotifications: "/user/web/notification",
    notificationPermission: "/user/permission",
    companyLogoUpload : "/user/add/company/logo",
    getEmployeeLeave : "/user/emp/leave/detail",
    getEmpLeaveReason : "/user/emp/leave/reason",
    fetchCompanyLogoDetails : "/user/get/company/logo",
    updateCompanyLogo : "/user/update/company/logo",
    getRequestAttendance : "/request/fetch/all/request",
    previewAttendanceRequest : "/request/action/request",
    getRequestAttendanceCount : "/request/fetch/request/count",
    exportCompanyLevelReport : "/reports/organization/attendance",
    exportEmployeeLevelReportAttendance : "/reports/individual/attendance",
    applyEmployeeLeave : "/user/apply/leave/web",
    createBroadcast :"/broadcast/create/broadcast",
    photoBroadcast : "/broadcast/add/image",
    getBroadcastDetails : "/broadcast/show/broadcast/history",
    getBroadcastInfo : "/broadcast/show/selected/history",
    getRaisedDisputes : "/user/show/dispute",
    performAction : "user/action/perform",
    getEmployeeList : "/user/employee/list",
    markAttendance : "/checkIn/mark/attendance/web",
    getCompanySettings : "/request/get/company/settings/list",
    updateCompanySetting : "/request/update/company/setting",
    verifyGeneratedToken : "/user/verify/product/requested/token",
    validateProductToken : "/user/validate/product/token",
    fetchEmployeeDetails : "/user/request/to/fetch/employee/list/from/bluewings",
    synchronizeUsers : "/user/synchronise/users/data"
}
const navigationLink = {
    backPage: -1,
    homeLink: "/",
    loginLink: "/login",
    authentication: "/authentication/*",
    forgetPasswordLink: "/forgot-password",
    companyRegLink: "/company-registration",
    adminProfileLink: "/admin-profile",
    officeTimingLink: "/office-timing",
    dashboardLink: "/dashboard",
    companyProfileLink: "/company-profile",
    serverError: "/server-error",
    congrats: "/congrats",
    companyProfile: "/company-profile",
    empProfile: "/employee-profile",
    PageNotFound: "/*",
    employeeData: "/employee-data",
    logout: "/logout",
    serverDown: "/server-down",
    serverAuthError: "/server-auth-error",
    setting: "/setting-page",
    changePassword: "/change-password",
    manageLeaves: "/manage-leaves",
    scheduleLeaves: "/manage-leaves/schedule-leaves",
    scheduleHoliday: "/manage-leaves/schedule-holiday",
    requestsAttendance : "/requests-attendance",
    companyLevelPdfExport : "/company-level/pdf-preview",
    employeeAttendancePreview : "/employee-profile/employee-attendance/pdf-preview",
    privacyPolicy : "/privacy-policy",
    broadcast : "/broadcast",
    createBroadCast : "/broadcast/create-broadcast",
    detailBroadcast: "/broadcast/detail-broadcast",
    markAttendance: "/mark-attendance",
}

const strings ={
    authTokenLabel : "authToken",
    sessionLabel : "session",
    newSessionLabel : "newSession",
    filesLabel : "files",
    idToSave : "idToSave"
}

const vapidKey = "BD5w4ijzFVh2wOIdnlZoHNs084WIKqsA27KWV2oiJoc8IXsYeDOymQcXp1wZfMqpfYnHZVRJvJSASn9UOOfGRa4";

const filterOptions = [
    { value: "Month", label: "Month" },
    { value: "This week", label: "This week" },
    { value: "Current month", label: "Current month" },
    { value: "Past 2 months", label: "Past 2 months" },
    { value: "Custom", label: "Custom" },
]

const companySizeList = [
    { value: 'Small (1 - 20)', label: 'Small (1 - 20)' },
    { value: 'Medium (20 - 200)', label: 'Medium (20 - 200)' },
    { value: 'Large (200 more than 2000)', label: 'Large (200 more than 2000)' },
];

const companyTypeList = [
    { value: 'Sole proprietorship', label: 'Sole proprietorship' },
    { value: 'Partnership', label: 'Partnership' },
    { value: 'Limited Liability Company(LLC)', label: 'Limited Liability Company(LLC)' },
    { value: 'Corporation', label: 'Corporation' },
    { value: 'S Corporation', label: 'S Corporation' },
    { value: 'C Corporation', label: 'C Corporation' },
    { value: 'B Corporation', label: 'B Corporation' },
    { value: 'Benefit Corporation', label: 'Benefit Corporation' },
    { value: 'Cooperative', label: 'Cooperative' },
    { value: 'Non-Profit Organization', label: 'Non-Profit Organization' },
    { value: 'Limited Liability Partnership(LLP)', label: 'Limited Liability Partnership(LLP)' },
    { value: 'Joint Venture(JV)', label: 'Joint Venture(JV)' },
    { value: 'Limited Partnership(LP)', label: 'Limited Partnership(LP)' },
    { value: 'Public Limited Company(PLC)', label: 'Public Limited Company(PLC)' },
    { value: 'Statutory Corporation', label: 'Statutory Corporation' },
    { value: 'Private Limited Company(Ltd)', label: 'Private Limited Company(Ltd)' },
    { value: 'Mutual Organization', label: 'Mutual Organization' },
    { value: 'Other', label: 'Other' },
];

const broadcastType =[
    { value : "In app", label: "In app" },
    { value : "Email" ,label: "Email" },
    {value : "In app , Email", label: "In app , Email"}
];

const reachabilityType =[
    { value : "All employee", label: "All employee" },
    { value : "Selected employee" ,label: "Selected employee" },
];

const localStorage = {
    selectedEmployeeId: "selectedEmployee",
    errorMessageLabel: "Something went wrong",
    statusLabel: "status"
}
const constantRoles = {
    adminLabel: "Admin",
    adminDobLabel: "adminDob"
}

const empList = [
    {
        label: EmployeeDetails.empTypeList.admin,
        id: 1
    },
    {
        label: EmployeeDetails.empTypeList.teamLead,
        id: 2
    }
]

const constantsErrors = {
    internetErrorLabel: "Please check your internet connection.",
    serverError: "Unable to connect with server",
    sessionExpire: "Session Expired",
    "toastErrorCode" : "error6" 
}

const dateFormatStrings ={
    "dateMonthLabel" :"DD/MM/YYYY",
    "monthDateLabel" : "YYYY/MM/DD"
 }

const inputPattern = {
    patternWithoutSpaceOne: /\S+/,
    patternWithoutSpaceSecond: /^(?! )[a-zA-Z ]*(?<! )$/,
    patternWithoutSpaceThird: /^(?! )[^\s](.*\S)?$/,
}

const errorCodeCharacter = String.fromCodePoint(9432);
const validationInfoIcon = { errorCodeCharacter };

const constants = {
    apiName,
    navigationLink,
    filterOptions,
    localStorage,
    empList,
    inputPattern,
    constantRoles,
    constantsErrors,
    vapidKey,
    companySizeList,
    companyTypeList,
    validationInfoIcon,
    dateFormatStrings,
    broadcastType,
    reachabilityType,
    strings
}

export default constants;